import {
  EXPECTED_PRICE_RANGE_DESER,
  ExpectedPriceRange,
  type SingleResponse,
} from "../../tastyworks"
import type HttpClient from "../../tastyworks/http"

const INSTRUMENT_TYPE_PATHS = {
  Equity: "equity",
  Future: "future",
} as const

export type ExpectedPriceRangeInstrumentType =
  keyof typeof INSTRUMENT_TYPE_PATHS

export class AccountExpectedPriceRangeService {
  constructor(private readonly accountNumberClient: HttpClient) {}

  readonly showEffective = async (
    accountNumber: string,
    instrumentType: ExpectedPriceRangeInstrumentType,
    underlyingSymbol: string
  ): Promise<SingleResponse<ExpectedPriceRange | null>> =>
    this.accountNumberClient.show(
      new ExpectedPriceRange(),
      EXPECTED_PRICE_RANGE_DESER.update,
      `/expected-price-ranges/${INSTRUMENT_TYPE_PATHS[instrumentType]}/:underlyingSymbol/effective`,
      { accountNumber, underlyingSymbol }
    )
}
